import "@arco-design/web-react/es/Badge/style";
import _Badge from "@arco-design/web-react/es/Badge";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import React from 'react';
export function DisplayOption({
  options,
  value,
  type = 'badge'
}) {
  const item = options.find(v => v.value === value);

  if (!item) {
    return /*#__PURE__*/React.createElement("div", null, "-");
  }

  if (type === 'tag') {
    return /*#__PURE__*/React.createElement(_Tag, {
      color: item.color
    }, item.label);
  }

  return /*#__PURE__*/React.createElement(_Badge, {
    color: item.color,
    text: item.label
  });
}